/* ================================================
   PETIT MÉNAGE — Product CRO JavaScript
   Archivo: assets/product-cro.js
   ================================================ */

(function () {
  'use strict';

  /* ── 1. ACORDEÓN ──────────────────────────────── */
  function initAccordion() {
    var accordion = document.getElementById('pm-accordion');
    if (!accordion) return;

    var triggers = accordion.querySelectorAll('.pm-accordion__trigger');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var isOpen    = trigger.getAttribute('aria-expanded') === 'true';
        var contentId = trigger.getAttribute('aria-controls');
        var content   = document.getElementById(contentId);
        var item      = trigger.closest('.pm-accordion__item');

        if (!content) return;

        if (isOpen) {
          /* Cerrar */
          trigger.setAttribute('aria-expanded', 'false');
          content.setAttribute('hidden', '');
          item.classList.remove('pm-accordion__item--open');
        } else {
          /* Abrir */
          trigger.setAttribute('aria-expanded', 'true');
          content.removeAttribute('hidden');
          item.classList.add('pm-accordion__item--open');
        }
      });
    });
  }


  /* ── 2. STICKY ADD-TO-CART ────────────────────── */
  function initStickyATC() {
    var stickyBar   = document.getElementById('pm-sticky-atc');
    var stickyBtn   = document.getElementById('pm-sticky-btn');
    if (!stickyBar || !stickyBtn) return;

    /* Detectar el botón ATC principal de Shopify.
       Ajusta el selector si tu tema usa uno diferente. */
    var mainBtn = document.querySelector(
      '[data-add-to-cart], .product-form__submit, #AddToCart, [name="add"]'
    );
    if (!mainBtn) return;

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        if (!entry.isIntersecting) {
          /* El botón principal salió de la vista → mostrar sticky */
          stickyBar.classList.add('pm-sticky-atc--visible');
          stickyBar.setAttribute('aria-hidden', 'false');
        } else {
          /* Volvió a la vista → ocultar sticky */
          stickyBar.classList.remove('pm-sticky-atc--visible');
          stickyBar.setAttribute('aria-hidden', 'true');
        }
      },
      { threshold: 0 }
    );

    observer.observe(mainBtn);

    /* El sticky ATC hace un fetch add-to-cart y luego abre el drawer/cart */
    stickyBtn.addEventListener('click', function () {
      var variantId = stickyBtn.getAttribute('data-variant-id');
      if (!variantId) return;

      stickyBtn.disabled   = true;
      stickyBtn.textContent = 'Añadiendo…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          stickyBtn.textContent = '¡Añadido!';
          stickyBtn.style.background = '#5C7A4E'; /* --pm-accent */

          /* Actualizar contador del carrito si tu tema lo tiene */
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var counters = document.querySelectorAll(
                '.cart-count, .cart__count, [data-cart-count], .js-cart-count'
              );
              counters.forEach(function (el) {
                el.textContent = cart.item_count;
              });
              /* Disparar evento para que el drawer del tema se abra */
              document.documentElement.dispatchEvent(
                new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } })
              );
            });

          setTimeout(function () {
            stickyBtn.disabled   = false;
            stickyBtn.textContent = 'Añadir al carrito';
            stickyBtn.style.background = '';
          }, 2500);
        })
        .catch(function () {
          stickyBtn.disabled   = false;
          stickyBtn.textContent = 'Error — reintentar';
          setTimeout(function () {
            stickyBtn.textContent = 'Añadir al carrito';
          }, 2500);
        });
    });

    /* Sincronizar variant-id cuando el usuario cambia variante */
    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) {
        stickyBtn.setAttribute('data-variant-id', e.detail.variant.id);
        var priceEl = document.querySelector('.pm-sticky-atc__price');
        if (priceEl && e.detail.variant.price) {
          priceEl.textContent = formatMoney(e.detail.variant.price);
        }
      }
    });
  }


  /* ── 3. BOTÓN "ESCRIBIR RESEÑA" → scroll ─────── */
  function initReviewButton() {
    var btn = document.querySelector('a[href="#pm-write-review"]');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      /* Si Judge.me está instalado, busca su formulario */
      var form = document.querySelector(
        '.jdgm-write-rev-link, .loox-rating, #shopify-product-reviews'
      );
      if (form) {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        form.focus && form.focus();
      }
    });
  }


  /* ── UTILIDAD: Formato de moneda (básico) ─────── */
  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2).replace('.', ',');
    return value + '\u00A0€';
  }


  /* ── INIT ─────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAccordion();
      initStickyATC();
      initReviewButton();
    });
  } else {
    initAccordion();
    initStickyATC();
    initReviewButton();
  }

})();
